import { render, staticRenderFns } from "./EtablissementItem.vue?vue&type=template&id=71894a9d"
import script from "./EtablissementItem.vue?vue&type=script&lang=js"
export * from "./EtablissementItem.vue?vue&type=script&lang=js"
import style0 from "./EtablissementItem.vue?vue&type=style&index=0&id=71894a9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports